"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.umbCountryStateProvinceDropDown = exports.UmbCountryStateProvinceDropDown = void 0;
const app_1 = require("app");
class UmbCountryStateProvinceDropDown extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.country-state-province-dropdown';
        this.stateValidationMessage = 'Please select state';
        this.countryLabelId = 'countryFieldLabel';
        this.divionsLabelId = 'divionsFieldLabel';
    }
    BeforeInit() {
        this.el.forEach(el => {
            this.initCurrentFormControl(el);
        });
    }
    initCurrentFormControl(el) {
        const countryFieldId = app_1.AttrService.data(el, 'countryfieldid');
        const divionsFieldId = app_1.AttrService.data(el, 'divionsfieldid');
        const modelId = app_1.AttrService.data(el, 'modelid');
        this.stateValidationMessage = app_1.AttrService.data(el, 'statevalidationmessage');
        const country = document.getElementById(countryFieldId);
        const division = document.getElementById(divionsFieldId);
        const combinedField = document.getElementById(modelId);
        document
            .getElementById(countryFieldId)
            .addEventListener('change', event => this.initCountries(event, country, division, combinedField));
        document
            .getElementById(divionsFieldId)
            .addEventListener('change', event => this.initCountries(event, country, division, combinedField));
    }
    initCountries(event, country, division, combinedField) {
        var _a;
        const countryLabel = document.getElementById(this.countryLabelId);
        const divionsLabel = document.getElementById(this.divionsLabelId);
        const wrapper = document.querySelector('.countrystateprovince');
        const validationMessage = wrapper.querySelector('.field-validation-error');
        if (event.target.id === country.id) {
            countryLabel.innerText = country.options[country.selectedIndex].text;
            this.removeDivisionOptions(division);
            divionsLabel.innerHTML = '-- Please Select --';
            this.getDivision(country.value, division);
            if (validationMessage) {
                validationMessage.className = 'field-validation-valid';
                validationMessage.textContent = '';
            }
            (_a = wrapper.querySelectorAll('select')[0]) === null || _a === void 0 ? void 0 : _a.classList.remove('input-validation-error');
        }
        else {
            divionsLabel.innerText = division.options[division.selectedIndex].text;
            this.removeStateValidationError(division);
        }
        // Update the value in the hidden field
        combinedField.value = country.value + '|' + division.value;
    }
    getDivision(countryCode, divisionSelect) {
        // API request
        (0, app_1.api)(`/umbraco/api/countrydivisions/GetDivisions?isocode=${countryCode}`, {})
            .then(response => {
            var _a;
            const { data } = response;
            const divionsLabel = document.getElementById(this.divionsLabelId);
            // Placeholder for state/region dropdown
            let placeholderOption = document.createElement('option');
            placeholderOption.value = '';
            placeholderOption.textContent = '-- Please Select --';
            divisionSelect.appendChild(placeholderOption);
            // Adds states/regions to the dropdown
            (_a = response.data) === null || _a === void 0 ? void 0 : _a.forEach(division => {
                let option = document.createElement('option');
                option.value = division.value;
                option.textContent = division.division;
                divisionSelect.appendChild(option);
            });
            if (data.length === 0) {
                divionsLabel.innerText = 'No States / Regions to select.';
                this.removeStateValidationError(divisionSelect);
            }
            else {
                this.addStateValidationError(divisionSelect);
            }
            // Enables the dropdown
            divisionSelect.disabled = data.length === 0;
        })
            .catch(() => {
            divisionSelect.innerHTML = '<option selected disabled>Error loading data</option>';
        });
    }
    addStateValidationError(divisionSelect) {
        const wrapper = document.querySelector('.countrystateprovince');
        const errorClassAdded = wrapper.querySelector('.form-state-error-message');
        if (!errorClassAdded) {
            const elem = document.createElement('p');
            elem.className = 'form-state-error-message form-helper-text text-error-primary';
            elem.innerText = this.stateValidationMessage;
            wrapper.querySelector('.form-field').appendChild(elem);
            divisionSelect.classList.add('input-validation-error');
        }
    }
    removeStateValidationError(divisionSelect) {
        const wrapper = document.querySelector('.countrystateprovince');
        const elements = wrapper.querySelectorAll('.form-state-error-message');
        elements.forEach(item => item.remove());
        divisionSelect.classList.remove('input-validation-error');
    }
    removeDivisionOptions(division) {
        const options = division.getElementsByTagName('option');
        for (let i = options.length; i--;) {
            division.removeChild(options[i]);
        }
    }
}
exports.UmbCountryStateProvinceDropDown = UmbCountryStateProvinceDropDown;
exports.umbCountryStateProvinceDropDown = new UmbCountryStateProvinceDropDown();
